var map = {
	"./arrow-down-blue.svg": 878,
	"./arrow-down-grey.svg": 879,
	"./arrow-right-white.png": 880,
	"./arrow-right.svg": 881,
	"./bg.png": 195,
	"./circle-grey.svg": 196,
	"./circle.svg": 80,
	"./coinbaseWalletIcon.svg": 882,
	"./download-on-the-appstore.png": 197,
	"./dropdown-blue.svg": 883,
	"./dropdown.svg": 884,
	"./dropup-blue.svg": 885,
	"./fortmaticIcon.png": 886,
	"./get-it-on-google-play.png": 198,
	"./github.png": 194,
	"./google.png": 193,
	"./magnifying-glass.svg": 310,
	"./metamask.png": 887,
	"./nanopro.png": 192,
	"./nas.png": 191,
	"./nextdao-dark.png": 888,
	"./nextdao.png": 889,
	"./nextdao@2x.png": 190,
	"./plus-blue.svg": 890,
	"./plus-grey.svg": 891,
	"./portisIcon.png": 892,
	"./question-mark.svg": 893,
	"./question.svg": 199,
	"./spinner.svg": 894,
	"./torus.png": 895,
	"./trustWallet.png": 896,
	"./walletConnectIcon.svg": 897,
	"./x.svg": 898
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 877;